import { takeEvery } from 'redux-saga/effects';
import {
  doError,
  doNavigate,
  doRestart,
  NAVIGATE,
  RESTART_FLOW,
  SHOW_ERROR,
} from './Commons';
import { doEmit, SUBMIT_EMIT_FORM } from './Emit';
import { doQuote, SELECT_PLAN, selectPlan, SUBMIT_QUOTE_FORM } from './Quote';
import { doFetchPdf, FETCH_PDF } from './Success';

export default function* sagas() {
  yield takeEvery(SUBMIT_QUOTE_FORM, doQuote);
  yield takeEvery(SELECT_PLAN, selectPlan);
  yield takeEvery(NAVIGATE, doNavigate);
  yield takeEvery(SUBMIT_EMIT_FORM, doEmit);
  yield takeEvery(SHOW_ERROR, doError);
  yield takeEvery(RESTART_FLOW, doRestart);
  yield takeEvery(FETCH_PDF, doFetchPdf);
}
